import React, { FC, useState } from 'react';
import handleKeyPress from '../../../common/handleKeyPress';
import { COLORS } from '../../../common/branding/colors';
import { BananatagButton, Checkbox, Modal } from '../../../componentLibrary';
import * as Styled from './styles';

interface Props {
    closeModal: () => void;
    onSubmit: (hideFutureWarnings: boolean) => void;
}

const SideBySideTags: FC<Props> = ({ closeModal, onSubmit }) => {
    const [isChecked, setIsChecked] = useState(false);

    return (
        <Modal onEsc={closeModal} width={591} height={567} dataTestId="side-by-side-tags-modal">
            <Styled.HeaderWrapper>
                <Styled.Icon icon="lightbulb-on" />
                <Styled.Header>Using personalization tags in a row</Styled.Header>
            </Styled.HeaderWrapper>
            <Styled.Text>
                Using tags side by side can be tricky. Ensure that applied fallbacks make sense in various combinations
                in the case a recipient is missing data.
            </Styled.Text>
            <Styled.Text>
                Example:{' '}
                <Styled.Bold>Hello &#123;&#123;firstName&#125;&#125; &#123;&#123;lastName&#125;&#125;,</Styled.Bold>
            </Styled.Text>
            <Styled.ExampleBackground>
                <Styled.Text>First name fallback: everyone</Styled.Text>
                <Styled.Text>
                    Last name fallback: <Styled.CodeText>{'<none>'}</Styled.CodeText>
                </Styled.Text>
                <Styled.Table>
                    <Styled.TableHeader>
                        <Styled.TableRow>
                            <th>Recipient is missing</th>
                            <th>Result</th>
                        </Styled.TableRow>
                    </Styled.TableHeader>
                    <Styled.TableBody>
                        <Styled.TableRow>
                            <td>First name</td>
                            <td>
                                <Styled.Bold>Hello everyone Ross,</Styled.Bold>
                            </td>
                        </Styled.TableRow>
                        <Styled.TableRow>
                            <td>Last name</td>
                            <td>
                                <Styled.Bold>Hello Bob,</Styled.Bold>
                            </td>
                        </Styled.TableRow>
                        <Styled.TableRow>
                            <td>Both first and last name</td>
                            <td>
                                <Styled.Bold>Hello everyone,</Styled.Bold>
                            </td>
                        </Styled.TableRow>
                    </Styled.TableBody>
                </Styled.Table>
            </Styled.ExampleBackground>
            <Styled.Acknowledgement>
                <Styled.CheckboxWrapper>
                    <Checkbox
                        icon={isChecked ? 'check_box' : 'check_box_outline_blank'}
                        color={isChecked ? COLORS.primary300 : 'lightgray'}
                        labelId="do-not-show-again"
                        isChecked={isChecked}
                        onClick={() => setIsChecked((prev) => !prev)}
                        onKeyDown={(e) => handleKeyPress(e, () => setIsChecked((prev) => !prev))}
                    />
                    {/* TODO: Checkbox component should be controllable by the label by taking an id */}
                    <Styled.CheckboxLabel onClick={() => setIsChecked((prev) => !prev)} id="do-not-show-again">
                        Mute this notification for one month
                    </Styled.CheckboxLabel>
                </Styled.CheckboxWrapper>
                <BananatagButton type="solid" size="large" onClick={() => onSubmit(isChecked)} text="got it!" />
            </Styled.Acknowledgement>
        </Modal>
    );
};

export default SideBySideTags;
